<template>
  <message @confirm="confirm" ref="add" :btn-name="btnName" :closeModal="closeModal" @dialogclose="dialogclose">
    <el-form ref="elFrom" :show-message="false" label-width="128px">
      <el-row>
        <template v-for="(from, index) in fromConfig">
          <el-col :span="24" :key="index" v-if="from.column">
            <div class="tabTitle" v-if="from.column">{{ from.column }}</div>
          </el-col>
          <el-col :span="24" :key="index" v-else-if="from.slot">
            <slot :name="from.key" :from="from"/>
          </el-col>
          <el-col :span="from.span || 8" v-else :key="index || from.key">
            <el-form-item :prop="from.key" :label="from.title" :class="[!from.notRequired ? 'title_active' : '']">
              <slot :name="from.key" :from="from">
                <el-input v-if="from.type === 'input'" :disabled="from.disabled" v-model="from.value"
                    :placeholder="`请输入${from.title}`">
                </el-input>
                <el-select
                    v-else-if="from.type === 'select'"
                    :disabled="from.disabled"
                    filterable
                    v-model="from.value"
                    :placeholder="`请选择${from.title}`"
                    @change="change(from)">
                  <el-option v-for="item in from.list" :key="item.value" :label="item.label" :value="item.value"/>
                </el-select>
                <el-select
                    v-else-if="from.type === 'selectMultiple'"
                    :disabled="from.disabled"
                    filterable
                    multiple
                    v-model="from.value"
                    :placeholder="`请选择${from.title}`"
                    @change="change(from)">
                  <el-option v-for="item in from.list" :key="item.value" :label="item.label" :value="item.value"/>
                </el-select>
                <el-select
                    v-else-if="from.type === 'select2'"
                    :disabled="from.disabled"
                    filterable
                    remote
                    @change="change(from)"
                    v-model="from.value"
                    :placeholder="`请选择${from.title}`"
                    :remote-method="(key) => from.querySearch(key, from)">
                  <el-option v-for="(item, index) in from.list" :key="item.value + index" :label="item.label"
                             :value="item.value"/>
                </el-select>
                <el-date-picker
                    v-else-if="from.type === 'date'"
                    :disabled="from.disabled"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="from.value"
                    type="datetime"
                    :placeholder="`请选择${from.title}`">
                </el-date-picker>
                <el-input
                    v-if="from.type === 'textarea'"
                    :autosize="{ minRows: 5, maxRows: 5}"
                    type="textarea"
                    :disabled="from.disabled"
                    v-model="from.value"
                    :placeholder="`请输入${from.title}`">
                </el-input>
                <el-autocomplete
                    v-else-if="from.type === 'autocomplete'"
                    v-model="from.value"
                    :label="'carNo'"
                    :disabled="from.disabled"
                    :value-key="from.valueKey"
                    :trigger-on-focus="false"
                    :fetch-suggestions="from.querySearch"
                    :placeholder="`请输入${from.title}`"
                    @select="from.select"
                    @input="change(from)">
                  <template slot-scope="{ item }">
                    {{ getFromValue(from.valueKey, item, from.valueKeyTitle) }}
                  </template>
                </el-autocomplete>
                <template v-else-if="from.type === 'upload'">
                  <el-upload
                      :show-file-list="false"
                      :disabled="from.disabled"
                      :headers="{'Authorization': getToken}"
                      :action="VUE_APP_URL+'/common/upload'"
                      :on-success="res => from.value=res.data">
                    <div class="upload">
                      <img style="width: 100%;height: 100%" v-if="from.value" :src="from.value">
                      <i v-else style="font-size: 25px" class="el-icon-plus avatar-uploader-icon"></i>
                    </div>
                  </el-upload>
                  <div v-if="from.value">
                    <el-image :ref="from.key" style="display: none"
                              :preview-src-list="[from.value]" fit="fit">
                    </el-image>
                    <a style="color: #00a0e9;cursor: pointer;" @click="$refs[from.key][0].showViewer = true">查看</a>
                  </div>
                </template>
                <el-checkbox-group
                    v-model="from.value"
                    v-else-if="from.type === 'elcheckbox'">
                  <el-checkbox v-for="item in from.list" :key="item.value" :label="item.value">{{ item.label }}
                  </el-checkbox>
                </el-checkbox-group>
                <div :id="from.id" v-else-if="from.type === 'wangeditor'" class="wangeditor"></div>
              </slot>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
    </el-form>
    <slot name="other"></slot>
  </message>
</template>

<script>
import {createProps} from '@/utils/createProps'
import {mapGetters} from 'vuex'
import axios from 'axios'
import E from 'wangeditor'

export default {
  data() {
    return {
      aaa: [],
      editor: {},
      formData: {},
      params: {},
      VUE_APP_URL: process.env.VUE_APP_URL
    }
  },
  props: {
    closeModal: createProps(true),
    fromConfig: createProps([]),
    btnName: createProps('保存'),
  },
  computed: {
    getFromValue() {
      return (key, row, _kt) => {
        if (_kt) {
          const _arr = [];
          _kt.forEach(item => _arr.push(row[item]));
          return _arr.join('-');
        } else {
          return row[key]
        }
      }
    },
    ...mapGetters('user', ['getToken']),
    getConfig() {
      return this.fromConfig
    }
  },
  methods: {
    dialogclose() {
      this.$nextTick(() => {
        for (const key in this.editor) {
          this.editor[key].destroy();
          delete this.editor[key];
        }
      })
    },
    close() {
      this.$refs.add.close();
    },
    change(from) {
      from.change && from.change();
    },
    open(data, params = {}, fn) {
      this.$refs.add.open();
      this.params = params;
      this.$nextTick(() => {
        this.resetForm();
        if (data) {
          this.getConfig.forEach(item => {
            if (item.column === '新 建') item.column = '编 辑';
            if (!item.notParam) {
              item.transform ? item.transform(data) : item.value = data[item.key];
            }
          })
        }
        this.getConfig.forEach(item => {
          if (item.type === 'wangeditor') {
            this.editor[item.id] = new E('#' + item.id);
            this.editor[item.id].config.menus = [
              'head',
              'bold',
              'fontSize',
              'fontName',
              'italic',
              'underline',
              'strikeThrough',
              'indent',
              'lineHeight',
              'foreColor',
              'backColor',
              'link',
              'list',
              'todo',
              'justify',
              'quote',
              'image',
              'table',
              'code',
              'splitLine',
              'undo',
              'redo',
            ]
            this.editor[item.id].config.showLinkImg = false;
            this.editor[item.id].config.uploadImgMaxLength = 1;
            this.editor[item.id].config.customUploadImg = (resultFiles, insertImgFn) => {
              const _config = {
                headers: {"Content-Type": "multipart/form-data"}
              }
              const _formData = new FormData();
              _formData.append('file', resultFiles[0], resultFiles[0].name)
              axios.post(this.VUE_APP_URL + '/common/upload', _formData, _config).then(res => {
                insertImgFn(res.data.data)
              }).catch(err => {
                console.error(err)
                this.$error("上传失败");
              })
            }
            this.editor[item.id].create();
            if (data) this.editor[item.id].txt.html(data[item.key])
          }
          if (item.clear) item.clear(data)
        })
        if (fn) fn();
      })
    },
    confirm() {
      this.getConfig.forEach(item => {
        if (item.type === 'wangeditor') {
          item.value = this.editor[item.id].txt.html();
        }
      })
      this.$emit('confirm', this.params);
    },
    resetForm() {
      this.$refs.elFrom.resetFields();
    }
  }
}
</script>

<style lang="less" scoped>
.el-select, .el-autocomplete {
  width: 100%;
}

/deep/ .el-form-item.is-error .el-input__inner {
  border-color: #DCDFE6 !important;
}

.tabTitle {
  width: 100px;
  height: 33px;
  background: rgba(22, 60, 120, 0.2);
  margin-bottom: 20px;
  border-radius: 0px 3px 3px 0px;
  text-align: center;
  line-height: 33px;
  font-size: 14px;
  color: #163C78;
  font-weight: bold;
}

/deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100%;
}

.title_active /deep/ .el-form-item__label:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

.upload {
  width: 108px;
  height: 108px;
  text-align: center;
  line-height: 106px;
  background: #fbfbfb;
  border: 1px solid #e4dddd;
  border-radius: 3px;
}

.wangeditor {
  height: 350px;
}
</style>
